<template>
  <div class="container">
    <Container :active_path="path" :plate="'项目巡览'">
      <div class="base-warp">
        <div class="head">
          <el-form :model="search" ref="form" label-width="80px" :inline="true" size="normal">
            <el-form-item label="用户名称">
              <el-input v-model="search.name" size="mini" placeholder="请输入用户名称进行查询"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="confirm">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-dialog v-bind="$attrs" v-on="$listeners" :visible.sync="dialogVisible" title="预约信息" width="30%">
            <el-row :gutter="15">
              <el-form ref="elForm" :model="formData" size="small" label-width="100px" label-position="left">
                <el-col :span="15">
                  <el-form-item label="用户名">
                    <el-input v-model="formData.name" show-word-limit disabled prefix-icon='el-icon-s-opportunity'
                      :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="15">
                  <el-form-item label="手机号">
                    <el-input v-model="formData.phone" disabled :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="15">
                  <el-form-item label="项目名称">
                    <el-input v-model="formData.projectname" disabled :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="15">
                  <el-form-item label="公司名称">
                    <el-input v-model="formData.companyname" disabled :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col> <el-col :span="15">
                  <el-form-item label="职位">
                    <el-input v-model="formData.position" disabled :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="15">
                  <el-form-item label="意见反馈">
                    <el-input v-model="formData.content" disabled :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="15">
                  <el-form-item label="预约时间">
                    <el-input v-model="formData.reser_time" disabled :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
            <div slot="footer">
              <!-- <el-button @click="close">取消</el-button> -->
              <el-button type="primary" @click="handleConfirm">确定</el-button>
            </div>
          </el-dialog>
        </div>
        <div class="table-box">
          <el-table :data="tabledata" border size="mini"
            :header-cell-style="{ background: '#f7f7f7', color: '#999', textAlign: 'center', fontWeight: 'normal' }">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="type" label="预约类别" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="name" label="用户名称" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="phone" label="手机号" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="projectname" label="项目名称" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="companyname" label="公司名称" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="position" label="职位" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="content" label="意见反馈" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="reser_time" label="预约时间" show-overflow-tooltip align="center"></el-table-column>

            <el-table-column prop="index" label="操作" width="210">
              <template slot-scope="s">
                <el-button type="warning" v-if="s.row.putaway" size="mini" disabled>已阅</el-button>
                <el-button type="danger" v-if="!s.row.putaway" size="mini" disabled>未阅</el-button>
                <el-button type="danger" size="mini" @click="del(s.row)">删除</el-button>
                <el-button type="primary" size="mini" @click="edit(s.row)" plain>查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination class="page-tion" @current-change="currentChange" layout="prev, pager, next" :page-size="pagesize"
          :total="total" background>
        </el-pagination>
      </div>
    </Container>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import Container from "../../../components/container"

export default {
  components: {
    Container,
  },
  data () {
    return {
      path: '/reallyWillBuy/items',
      search: {
        name: '',
      },
      dialogVisible: false,
      pageNo: 1,
      pagesize: 14,
      formData: {
        id: '',
        name: '',             //项目名称
      },

      tabledata: [],
      total: 0,
      imageUrl: ''
    }
  },
  mounted () {

    this.getTableData();
  },
  methods: {
    edit (row) {
      this.dialogVisible = true
      this.formData = row
      if (row.putaway == 1) {
        return
      } else {
        new Date()
        var params = {
          id: row.id,
          putaway: row.putaway
        }
        this.$api.projectReservationOrderViewing(params).then(res => {
          console.log(res);
        })
      }

    },
    close () {
      this.dialogVisible = false
      this.getTableData()

    },
    handleConfirm () {
      this.dialogVisible = false
      this.getTableData()
    },

    confirm () {
      this.pageNo = 1;
      this.getTableData();
    },
    currentChange (page) {
      this.pageNo = page;
      this.getTableData();
    },
    del (row) {
      this.$confirm("是否确定删除 " + row.name + ' 的预约信息').then(
        (confirm) => {
          var params = {
            id: row.id
          };
          this.$api.delprojectReservationOrderListQuery(params).then((data) => {
            this.$message.success(data);
            this.getTableData();
          });
        },
        (cancel) => { }
      );
    },
    getTableData () {
      var params = {
        name: this.search.name
      }
      this.$api.projectReservationOrderListQuery(params).then(data => {
        let { list, total } = data;
        this.tabledata = list;
        this.total = total;
      })
    },
  },

}
</script>

<style lang="scss" scoped>
.el-rate {
  display: inline-block;
  vertical-align: text-top;
}

.el-upload__tip {
  line-height: 1.2;
}

.right-edit-box {
  position: absolute;
  right: 0;
  top: 0;
}

.el-carousel__item {
  background: #fff;
  border: 1px dashed #999;

  .img {
    width: 270px;
    height: 202px;
    vertical-align: middle;
    position: relative;
  }

  .name {
    position: absolute;
    color: #fff;
    padding: 0 6px;
    background: rgba(0, 0, 0, 0.4);
    bottom: 4px;
    left: 4px;
  }
}

.left-row {
  border: 1px dashed #d9d9d9
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  margin: 0 auto;
}
</style>